import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MyOrderPage } from '../my-order/my-order';
import { OrderProvider } from '../../providers/order/order';
import { SubmittedOrder } from '../../models/submitted-order';

@IonicPage()
@Component({
  selector: 'page-my-orders',
  templateUrl: 'my-orders.html',
})
export class MyOrdersPage {

  orders: Array<SubmittedOrder>;

  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              private orderProvider: OrderProvider) {
                orderProvider.getSubmitted().then(x => {
                  console.log(x);
                  this.orders = x;
                });
  }

  ionViewDidLoad() {

  }

  openOrder(order: SubmittedOrder){
    this.navCtrl.push(MyOrderPage, {'order': order});
  }
}


// WEBPACK FOOTER //
// ./src/pages/my-orders/my-orders.ts